/**
 * Copyright (c) 2025, WSO2 LLC. (https://www.wso2.com).
 *
 * WSO2 LLC. licenses this file to you under the Apache License,
 * Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied. See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

/**
 * Removes a trailing slash from a path string if it exists.
 *
 * @param path - The string path to process
 * @returns The path without a trailing slash
 *
 * @example
 * ```typescript
 * removeTrailingSlash('/path/to/something/') // returns '/path/to/something'
 * removeTrailingSlash('/path/to/something') // returns '/path/to/something'
 * ```
 */
const removeTrailingSlash = (path: string): string => (path.endsWith('/') ? path.slice(0, -1) : path);

export default removeTrailingSlash;
